import { RefreshTokenViewModel } from '@apis/model/partner/RefreshTokenViewModel';
import { BaseResponse } from '@ul/api/lib/models/BaseResponse';

export const toRefreshTokenViewModel = (refreshTokenResponse: BaseResponse): RefreshTokenViewModel => {
    const { success, responseCode } = refreshTokenResponse;
    return {
        success,
        responseCode,
    };
};
